import DateFnsUtils from '@date-io/date-fns';
const dateFns = new DateFnsUtils();

import { DEFAULT_DATE_FORMAT } from './reports';

export const PAYMENT_ALERT =
  "Please top up your balance till 10th of {CURRENT_MONTH}. Don't lose your access to the platform.";

export const ACTIVE = 'active';

export const NEW = 'new';

export const REMOVED = 'removed';

export const SSP_LOGO_EXTENSIONS = ['.jpeg', '.jpg', '.png'];

export const SSP_LOGO_MAX_RESOLUTION = { width: 1000, height: 1000 };

export const MAX_FILE_SIZE = 1500 * 1024;

export const ALL = 'ALL';

export const ADM = 'adm';

export const UBIDEX_GATEWAY = 'UBIDEX_GATEWAY';

export const MANUAL_INTEGRATION = 'MANUAL_INTEGRATION';

export const PICKER_MIN_DATE_STR = '2023-01-01';
export const PICKER_MIN_DATE = dateFns.parse(
  PICKER_MIN_DATE_STR,
  DEFAULT_DATE_FORMAT,
);

export const ADM_FORMAT = {
  html: 'html',
  xml: 'xml',
  vast_3_0: 'vast 3.0',
  json: 'json',
};

export const QUERY_KEY_ENTITY = {
  WL: 'WL',
  ENDPOINT: 'ENDPOINT',
  PUBLISHER: 'PUBLISHER',
  CHART: 'CHART',
  REPORT: 'REPORT',
  BALANCES_REPORT: 'BALANCES_REPORT',
  CURRENT_USER: 'CURRENT_USER',
  BALANCE: 'BALANCE',
  SETTINGS: 'SETTINGS',
  BUDGET: 'BUDGET',
  WLID_TRANSACTIONS: 'WLID_TRANSACTIONS',
  USER: 'USER',
  ROLE: 'ROLE',
  UGW_TRANSACTIONS: 'UGW_TRANSACTIONS',
  CLIENT_TRANSACTIONS: 'CLIENT_TRANSACTIONS',
  PUBLISHER_PAYMENT_TRANSACTIONS: 'PUBLISHER_PAYMENT_TRANSACTIONS',
};
export const QUERY_KEY_TYPE = {
  LIST: 'LIST',
  DETAILS: 'DETAILS',
  DROPDOWN: 'DROPDOWN',
};

// keep in sync with SA version
export const PERMISSIONS = {
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  CLIENTS_READ: 'CLIENTS_READ',
  CLIENTS_MANAGEMENT: 'CLIENTS_MANAGEMENT',
  PUBLISHERS_READ: 'PUBLISHERS_READ',
  PUBLISHERS_MANAGEMENT: 'PUBLISHERS_MANAGEMENT',
  ANALYTICS_REPORT_READ: 'ANALYTICS_REPORT_READ',
  BALANCES_REPORT_READ: 'BALANCES_REPORT_READ',
  TRANSACTIONS_READ: 'TRANSACTIONS_READ',
  TRANSACTIONS_MANAGEMENT: 'TRANSACTIONS_MANAGEMENT',
};

export const RTB_PROTOCOL_VERSIONS = {
  AUTO: 'auto',
  EXO: 'exo',
};

export const publisherContentCategory = {
  MIXED: 'MIXED',
  MAINSTREAM: 'MAINSTREAM',
  ADULT: 'ADULT',
};

export const TOKEN_COOKIE = 'admin-token';

export const alertTypes = {
  ssl_track: 'ssl_track',
  ssl_app: 'ssl_app',
  domain_track: 'domain_track',
  domain_app: 'domain_app',
  payment: 'payment',
};

// threshold at which payment endDate should be red
export const WL_LIST_PAYMENT_WARNING_RANGE_DAYS = 14;
